//# sourceMappingURL=document.mjs.map
/// <reference types="./document.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function document() {
  return $svg.square(
    24,
    "<path d=\"M20 22.0845H4C3.73478 22.0845 3.48043 21.9791 3.29289 21.7916C3.10536 21.604 3 21.3497 3 21.0845V3.08447C3 2.81926 3.10536 2.5649 3.29289 2.37737C3.48043 2.18983 3.73478 2.08447 4 2.08447H20C20.2652 2.08447 20.5196 2.18983 20.7071 2.37737C20.8946 2.5649 21 2.81926 21 3.08447V21.0845C21 21.3497 20.8946 21.604 20.7071 21.7916C20.5196 21.9791 20.2652 22.0845 20 22.0845ZM19 20.0845V4.08447H5V20.0845H19ZM8 7.08447H16V9.08447H8V7.08447ZM8 11.0845H16V13.0845H8V11.0845ZM8 15.0845H13V17.0845H8V15.0845Z\" fill=\"currentColor\"/>",
  );
}
